import { useCMSPageField } from '@/cms/fields'
import { useIntl } from '@/intl'

interface DestinationTitleValues extends Record<string, string> {
  destinationName: string
  preposition: string
}

interface UseDestinationTitleValuesOptions {
  shouldUseSpecialPreposition: boolean
}

export function useDestinationTitleValues({
  shouldUseSpecialPreposition,
}: UseDestinationTitleValuesOptions): DestinationTitleValues {
  const intl = useIntl()
  const destinationName = useCMSPageField('DestinationPage.productName')
  const cmsPreposition = useCMSPageField('DestinationPage.preposition')
  const defaultPreposition = intl.formatMessage({ id: 'destination_default_preposition' })

  return {
    destinationName,
    preposition: shouldUseSpecialPreposition ? (cmsPreposition ?? defaultPreposition) : defaultPreposition,
  }
}
